require('/Users/xinyan/project/cn-ui-layout/node_modules/@cainiaofe/cn-error-feedback/es/style.js');
import CnErrorFeedback from "./view";
export default CnErrorFeedback;
export { CnErrorFeedback };
export * from "./const";
export * from "./type";